module.exports = __webpack_public_path__ + "static/media/icon-map.7790c721.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/checkout-summary/icon-map.svg
// module id = 480
// module chunks = 0 1 2